import serverCall from "../../serverCall";

const createMultiImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/add-multiImage`, data
    );
    return response;
};

const GetAllMultImages = async (id) => {
    const response = await serverCall.get(`/category/admin/all-category`);
    return response;
};

const DeleteMulti = async (id) => {
    const response = await serverCall.delete(`/category/admin/${id}`);
    return response;
};

const MultiImageService = {
    createMultiImage,
    GetAllMultImages,
    DeleteMulti
};

export default MultiImageService;
